import type { WarrantyPublicOfferView } from "@slfinrtl/ui-bff-routes"
import { useContext } from "react"
import type { EditMode } from "src/components"
import { ErrorHandlerContext } from "src/context/errorHandler/ErrorHandlerContext"
import { ErrorNotificationInline } from "src/context/errorHandler/ErrorNotificationInline"
import { WarrantySkeleton } from "src/screens/common/porscheApproved/WarrantySkeleton"
import type { VehicleDetailsStage } from "src/screens/vehicleDetails/common/VehicleDetailsStage"
import { PorscheApprovedVehicleEditContent } from "./PorscheApprovedVehicleEditContent"

interface PorscheApprovedVehicleEditStageProps {
	mode: EditMode
	saveDealerDecision: (approved: boolean) => Promise<void>
	setEditStage: (stage: VehicleDetailsStage | undefined) => void
	view: WarrantyPublicOfferView | undefined
}

export const PorscheApprovedVehicleEditStage = ({
	mode,
	saveDealerDecision,
	setEditStage,
	view,
}: PorscheApprovedVehicleEditStageProps) => {
	const errorContext = useContext(ErrorHandlerContext)

	if (errorContext?.error) {
		return <ErrorNotificationInline dismissButton={false} />
	}
	return view ? (
		<PorscheApprovedVehicleEditContent
			initialViewState={view}
			isEditMode={mode === "edit"}
			dismissEditMode={() => setEditStage(undefined)}
			saveDealerDecision={saveDealerDecision}
		/>
	) : (
		<WarrantySkeleton isEditMode={false} />
	)
}
